<template>
  <span>{{val}} <i class="el-icon-copy-document" @click="fun_copy"></i></span>
</template>

<script>
import ClipboardJS from "clipboard";
export default {
  name: 'CompCopy',
  props:['val'],
  data() {
    return {
    }
  },
  methods: {
    fun_copy(){
      ClipboardJS.copy(this.val)
      this.$message.success('已复制到剪切板')
    },
    fun_on_load(){},
  },
  mounted() {
    this.fun_on_load();
  },
}
</script>

<style>
.el-icon-copy-document{color:var(--bs-primary);cursor:pointer;}
</style>